import React, { Component } from 'react';

 
const NoGpsAction = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowNoGPSKpi(props);
    };
    
   // if(props.data.msil_transit_delay == 1)
    //{
   //     var colr = 'redfont'
   // }
   // else{
       
            var colr = 'txt-danger'
      
    //}
    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
            title="GPS Not Available" ><i className={"icofont icofont-social-google-map "+(colr)}></i> &nbsp;</button>
            
        </div>
    );
};

export default NoGpsAction;
